import { useTexts } from './hooks/useTexts';
import { CalledTable } from './parts/CalledTable';
import { CallFunctionalityButtons } from './parts/CallFunctionalityButtons';
import { Filters } from './parts/Filters';

export function AdmissionCall() {
  const texts = useTexts();
  return (
    <>
      <div className="fs-16 my-2">{texts.subtitle}</div>
      <Filters />
      <CallFunctionalityButtons />
      <CalledTable />
    </>
  );
}
